export const MENU_COLLECTIONS = [
    {
        id: "classic-saga",
        name: "The Classic Saga",
        note: "The Roots of Hyderabad — Pure, Traditional & Timeless",
        items: [
            {
                name: "Classic Meetha",
                price: 50,
                kcal: 90,
                image: "saga-varq-paan.jpg",
                description: "Our signature Kolkata leaf, sweet gulkand, saunf & secret chuski mix. Simple, cool & evergreen. Where the Saga began.",
            },
            {
                name: "Shahi Meetha",
                price: 50,
                kcal: 95,
                image: "menu-shahi-meetha.jpg",
                description: "Rich gulkand loaded with dry fruits & kesar. A truly shahi, mouth-watering experience for royal taste.",
            },
            {
                name: "Magai Meetha",
                price: 60,
                kcal: 60,
                image: "saga-classic-paan.jpg",
                description: "Made with the softest Maghai paan leaf from Bihar. Extra soft, extra sweet & melts in mouth instantly.",
            },
            {
                name: "Banarsi Meetha",
                price: 60,
                kcal: 70,
                image: "menu-banarsi-meetha.jpg",
                description: "Straight from Banaras — authentic Banarasi style: extra gulkand, kattha-free & super refreshing. The holy taste of Kashi.",
            },
            {
                name: "Honey Fig Meetha",
                price: 80,
                kcal: 90,
                image: "saga-honey-fig.jpg",
                description: "Real honey & imported Turkish figs stuffed in meetha paan. Natural sweetness, low calorie & super premium.",
            },
        ],
    },
    {
        id: "couverture-saga",
        name: "The Couverture Saga",
        note: "Made With Real Belgian Couverture Chocolate",
        items: [
            {
                name: "Dark Couverture",
                price: 70,
                kcal: 105,
                image: "menu-dark-couverture.jpg",
                description: "Intense 70% Belgian dark chocolate dipped. Bold, bittersweet & rich in antioxidants. For true dark lovers.",
            },
            {
                name: "Milk Couverture",
                price: 70,
                kcal: 105,
                image: "menu-milk-couverture.jpg",
                description: "Smooth & creamy Belgian milk chocolate dipped. Perfectly balanced, rich & indulgent.",
            },
            {
                name: "Golden Rocher",
                price: 100,
                kcal: 140,
                image: "saga-golden-rocher.jpg",
                description: "Ferrero Rocher stuffed inside, dipped in hazelnut milk couverture. Hyderabad's most luxurious paan.",
            },
            {
                name: "Cookies & Cream",
                price: 70,
                kcal: 70,
                image: "menu-cookies-cream.jpg",
                description: "White couverture dipped paan rolled in Oreo crumble. Creamy, crunchy & addictive.",
            },
            {
                name: "Crunchy Kitkat",
                price: 70,
                kcal: 120,
                image: "menu-crunchy-kitkat.jpg",
                description: "Meetha paan rolled in crunchy KitKat bits & dipped in milk couverture. Extra loud crunch in every bite.",
            },
        ],
    },
    {
        id: "fusion-saga",
        name: "The Fusion Saga",
        note: "Where Tradition Meets The Trend",
        items: [
            {
                name: "Mango Magic",
                price: 60,
                kcal: 100,
                image: "menu-mango-magic.jpg",
                description: "Mango cream infused meetha paan. King of fruits, king of taste.",
            },
            {
                name: "Crunchy Butterscotch",
                price: 60,
                kcal: 105,
                image: "menu-butterscotch-crunch.jpg",
                description: "Buttery caramel butterscotch chips loaded with creamy base. Sweet, crunchy & caramel dream.",
            },
            {
                name: "Strawberry Saga",
                price: 60,
                kcal: 120,
                image: "menu-strawberry-saga.jpg",
                description: "Dry strawberry with creamy notes. Berry sweet, pink & totally Insta-worthy.",
            },
            {
                name: "Pistachio Punch",
                price: 60,
                kcal: 105,
                image: "menu-pistachio-punch.jpg",
                description: "Premium California pistachios crushed & rolled in meetha paan with pista nuts. Rich, nutty & royal.",
            },
            {
                name: "Malai Saga",
                price: 60,
                kcal: 110,
                image: "menu-malai-saga.jpg",
                description: "The creamy dream — malai cream stuffed in meetha paan. Extra creamy, extra soft & melts like ice cream.",
            },
        ],
    },
    {
        id: "og-blend-saga",
        name: "The OG Blend Saga",
        note: "The Chatni Paan — Strong Flavour, Strong Aroma, Strong Kick",
        items: [
            {
                name: "Meenakshi Chatni",
                price: 40,
                image: "menu-meenakshi-chatni.jpg",
                description: "Hyderabad's iconic meenakshi chatni. Sweet, salty, aromatic & perfectly balanced.",
            },
            {
                name: "Nauratan Chatni",
                price: 50,
                image: "menu-nauratan-chatni.jpg",
                description: "A royal mix of 9 premium chatni masalas. Chatpata, tangy, sweet — every bite a new flavour.",
            },
            {
                name: "Sadhna Chatni",
                price: 50,
                image: "menu-sadhna-chatni.jpg",
                description: "A special signature blend with a unique mix of sweet, fruity & aromatic notes. Simple yet unforgettable.",
            },
            {
                name: "Dil Bahar Chatni",
                price: 50,
                image: "menu-dil-bahar-chatni.jpg",
                description: "Dil khush kar de wali chatni. Extra chatpata, extra fresh & totally addictive.",
            },
            {
                name: "Kasturi Chatni",
                price: 50,
                image: "menu-kasturi-chatni.jpg",
                description: "A rich intense musk flavoured chatni. Strong aroma, deep flavour & long-lasting taste.",
            },
            {
                name: "Saffron Chatni",
                price: 50,
                image: "menu-saffron-chatni.jpg",
                description: "Kesar-infused premium chatni paan. Rich, warm & luxurious chatni flavour.",
            },
        ],
    },
    {
        id: "signature-saga",
        name: "The Signature Saga",
        note: "Hyderabad's Most Loved Flavoured Paan",
        items: [
            {
                name: "Axe Saga",
                price: 50,
                image: "menu-axe-saga.jpg",
                description: "An intense cool axe flavour with a refreshing minty blast. Bold, fresh & long lasting.",
            },
            {
                name: "Night Queen Saga",
                price: 50,
                image: "menu-night-queen.jpg",
                description: "A mysterious raat-rani floral paan. Sweet, aromatic & truly unforgettable.",
            },
            {
                name: "Watermelon Saga",
                price: 50,
                image: "menu-watermelon-saga.jpg",
                description: "Juicy watermelon burst in every bite. Super refreshing, hydrating & perfect for summer.",
            },
            {
                name: "Mango Jamun Saga",
                price: 50,
                image: "menu-mango-jamun.jpg",
                description: "Double dhamaka of sweet mango and tangy jamun pulp — a unique, irresistible fusion.",
            },
            {
                name: "Butterscotch Saga",
                price: 50,
                image: "menu-butterscotch-saga.jpg",
                description: "Rich caramel with crunchy butterscotch chips. Smooth, sweet & indulgent.",
            },
            {
                name: "Lychee Saga",
                price: 50,
                image: "menu-lychee-saga.jpg",
                description: "Juicy, exotic & delightfully refreshing.",
            },
        ],
    },
    {
        id: "fruit-saga",
        name: "The Fruit Saga",
        note: "An exotic collection of fruits infused in chatni paan",
        items: [
            {
                name: "Pineapple Pop Saga",
                price: 60,
                image: "menu-pineapple-pop.jpg",
                description: "Zesty pineapple pulp burst in Pineapple Chatni blend. Tropical & refreshing.",
            },
            {
                name: "Mango Mania Saga",
                price: 60,
                image: "menu-mango-mania.jpg",
                description: "Juicy mango pulp infused. The King, now in a paan.",
            },
            {
                name: "Strawberry Blush Saga",
                price: 60,
                image: "menu-strawberry-blush.jpg",
                description: "Strawberry pulp made with creamy notes. Sweet & Insta-worthy.",
            },
            {
                name: "Jamun Jolt Saga",
                price: 60,
                image: "menu-jamun-jolt.jpg",
                description: "Tangy kala jamun with chatpata twist. Khatta-meetha nostalgia.",
            },
            {
                name: "Blueberry Blast Saga",
                price: 60,
                image: "menu-blueberry-blast.jpg",
                description: "A luscious blueberry blast, wrapped in the magic of paan.",
            },
            {
                name: "Kiwi Twist Saga",
                price: 60,
                image: "menu-kiwi-twist.jpg",
                description: "Tangy kiwi pulp explosion. Exotic, juicy & totally different.",
            },
        ],
    },
];

export const EXPERIENCE_POINTS = [
    { title: "Premium Ingredients" },
    { title: "Traditional Craftsmanship" },
    { title: "Modern Presentation" },
    { title: "Attention to Detail" },
];

export const SPACE_PHOTOS = [
    { src: "/assets/gallery-1.jpg", alt: "Inside the Paan Saga outlet — the display counter and lit shelves of paan ingredients" },
    { src: "/assets/gallery-2.jpg", alt: "Shelves of colourful paan ingredients in jars against the concrete wall at Paan Saga" },
    { src: "/assets/gallery-3.jpg", alt: "Three Saga team members in black uniforms crafting paan behind the counter" },
    { src: "/assets/gallery-4.jpg", alt: "The digital menu display wall showing Paan Saga products and their preparation" },
    { src: "/assets/gallery-6.jpg", alt: "The Paan Saga storefront at night — lit signage above the glass front with a view of the mint-green counter" },
    { src: "/assets/gallery-7.jpg", alt: "Inside Paan Saga — the entrance view with the story wall, display screens and the mint-green counter" },
    { src: "/assets/gallery-9.jpg", alt: "The Paan Saga counter with the mint-green front, pastry display and shelves of ingredients" },
    { src: "/assets/gallery-10.jpg", alt: "The pastry display case and drink cooler beside the digital menu screens at Paan Saga" },
    { src: "/assets/gallery-8.jpg", alt: "Paan Saga's illuminated signage with the leaf emblem and the 100% Tobacco Free plaque" },
    { src: "/assets/gallery-5.jpg", alt: "A Saga team member handing over the signature red carry bag across the paan display case" },
];

export const REVIEWS = [
    {
        title: "An Unexpectedly Premium Pan Experience!",
        stars: 5,
        quote: "I genuinely didn't expect a pan shop to feel this premium, but Paan Saga completely changed that perception. Their variety is impressive — from classic Meenakshi pan to modern, indulgent options like the Ferrero Rocher pan. Every single pan feels thoughtfully crafted, with top-notch quality and unforgettable taste. The hygiene standards are excellent, the service is quick and welcoming, and those small touches — like providing wet tissues — add a surprisingly luxurious feel.",
        source: "Guest review · Food 5/5 · Service 5/5 · Atmosphere 5/5",
    },
    {
        stars: 5,
        quote: "Excellent pan palace to have a rich varieties of fresh pan. We tried special sweet pan and normal sweet pan. Believe me — too good in taste. Must visit shop.",
        source: "Guest review · Food 5/5 · Service 5/5 · Atmosphere 5/5",
    },
    {
        quote: "The name itself, along with the entire vibe of the place, draws people in and tempts them to try the variety of paans offered here. The ambiance is very cozy and welcoming, the staff is courteous, and cleanliness is well maintained. Though the place feels somewhat premium, I find the prices to be quite reasonable.",
        source: "Guest review",
    },
];
